import AbstractWidget from "@/models/PlatinumWidget/AbstractWidget";
import PlatinumWidget from "@/models/PlatinumWidget/PlatinumWidget";
import Region from "@/models/Region/Region";

export default class Map extends AbstractWidget {

    static apiUrl = 'platinum-widget/map';

    static entity = 'platinumWidgetMaps';

    static model_name = 'Map';

    static fields() {
        return {
            id: this.number(null).nullable(),
            region_id: this.number(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            widget: this.hasOne(PlatinumWidget, 'widgetable_id'),
            region: this.hasOne(Region, 'region_id'),
        }
    }

    Widget() {
        return PlatinumWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }
}
